import { i as C } from "./index-BhCLFOCv.js";
import { default as P } from "./utils/Key/Key.js";
import { default as f } from "./utils/LabeledPromise/LabeledPromise.js";
import { default as y } from "./utils/ProgressPromise/ProgressPromise.js";
import { default as I } from "./utils/SmartVec/SmartVec.js";
import { default as v } from "./utils/sortNumericRange/sortNumericRange.js";
const t = {
  sidebarMenuItems: {
    newDcrButton: "sidebar__sidebarMenuItems__newDcrButton",
    homeButton: "sidebar__sidebarMenuItems__homeButton",
    dcrList: "sidebar__sidebarMenuItems__dcrList",
    userAvatar: "sidebar__sidebarMenuItems__userAvatar",
    userSignOut: "sidebar__sidebarMenuItems__userSignOut",
    dcrListItem: "sidebar__sidebarMenuItems__dcrListItem",
    publisherPortalButton: "sidebar__sidebarMenuItems__publisherPortalButton",
    dataPartnerPortalButton: "sidebar__sidebarMenuItems__dataPartnerPortalButton",
    datalabsButton: "sidebar__sidebarMenuItems__datalabsButton"
  }
}, a = {
  draftDataRoom: {
    dataTab: "containers__draftDataRoom__dataTab",
    computationsTab: "containers__draftDataRoom__computationsTab",
    permissionsTab: "containers__draftDataRoom__permissionsTab",
    overviewTab: "containers__draftDataRoom__overviewTab"
  },
  mediaDataRoom: {
    data: "containers__mediaDataRoom__data",
    insights: "containers__mediaDataRoom__insights",
    activation: "containers__mediaDataRoom__activation",
    auditLog: "containers__mediaDataRoom__auditLog"
  }
}, e = {
  computeNodeNameEditor: {
    nameInput: "computeNode__computeNodeNameEditor__nameInput",
    nameInputHelper: "computeNode__computeNodeNameEditor__nameInputHelper"
  },
  computeNodeToggle: {
    helper: "computeNode__computeNodeToggle__",
    nativeSql: "computeNode__computeNodeToggle__native-sql",
    sql: "computeNode__computeNodeToggle__sql",
    matching: "computeNode__computeNodeToggle__matching",
    s3: "computeNode__computeNodeToggle__s3",
    post: "computeNode__computeNodeToggle__post",
    airlock: "computeNode__computeNodeToggle__airlock",
    python: "computeNode__computeNodeToggle__python",
    r: "computeNode__computeNodeToggle__r",
    synthetic: "computeNode__computeNodeToggle__synthetic"
  },
  computeNodesActionButton: {
    testComputeNodes: "computeNode__computeNodesActionButton__testComputeNodes",
    retrieveResult: "computeNode__computeNodesActionButton__retrieveResult"
  },
  computeNodeCreator: {
    deleteColumn: "computeNode__computeNodeCreator__deleteColumn",
    newComputation: "computeNode__computeNodeCreator__newComputation",
    inputEditorLabel: "computeNode__computeNodeCreator__inputEditorLabel",
    selectHelper: "computeNode__computeNodeCreator__",
    unstructuredData: "computeNode__computeNodeCreator__unstructured_data",
    myTable: "computeNode__computeNodeCreator__my_table",
    demographicData: "computeNode__computeNodeCreator__demographic_data",
    patientData: "computeNode__computeNodeCreator__patient_data",
    ageRange: "computeNode__computeNodeCreator__age range",
    includeStatistics: "computeNode__computeNodeCreator__include_statistics",
    toggleEditor: "computeNode__computeNodeCreator__toggleEditor"
  },
  computeNodeEditor: {
    datasetRequired: "computeNode__computeNodeEditor__datasetRequired",
    maskPatientData: "computeNode__maskingHelper__Patient ID",
    maskingHelper: "computeNode__maskingHelper__",
    maskingIban: "computeNode__maskingHelper__IBAN",
    previewDataFrom: "computeNode__computeNodeEditor__previewDataFrom",
    dataMyTable: "computeNode__computeNodeEditor__my_table",
    dataHelper: "computeNode__computeNodeEditor__",
    dataSize: "computeNode__computeNodeEditor__dataSize"
  },
  syntethicNodeEditor: {
    datasetDropdown: "computeNode__syntethicNodeEditor__datasetDropdown",
    helper: "computeNode__syntethicNodeEditor__",
    demographicData: "computeNode__syntethicNodeEditor__demographic_data",
    patientData: "computeNode__syntethicNodeEditor__patient_data",
    myTable: "computeNode__syntethicNodeEditor__my_table",
    includeStatistics: "computeNode__syntethicNodeEditor__include_statistics"
  },
  matchingNode: {
    compareSelect: "computeNode__matchingNode__compareSelect",
    compareSelectHelper: "computeNode__matchingNode__compareSelectHelper__",
    compareToSelect: "computeNode__matchingNode__compareToSelect",
    compareToSelectHelper: "computeNode__matchingNode__compareToSelectHelper__"
  }
}, o = {
  unlockKeychain: {
    submitButton: "keychain__unlockKeychain__submitButton",
    keychainInput: "keychain__unlockKeychain__keychainInput"
  }
}, _ = {
  tabList: {
    organizations: "adminPortal__tabList__organizations"
  },
  organizations: {
    search: "adminPortal__organizations__search",
    recordHelper: "adminPortal__organizations__oranization__"
  },
  organizationTabList: {
    settings: "adminPortal__organizationTabList__settings",
    publisherConfigurations: "adminPortal__organizationTabList__publisherConfigurations",
    dataPartnerConfigurations: "adminPortal__organizationTabList__dataPartnerConfigurations"
  }
}, i = {
  datasetProvisionDialog: {
    import: "dataroom__datasetProvisionDialog__import",
    storedDataset: "dataroom__datasetProvisionDialog__dataset"
  },
  dataRoomTypeSelectDialog: {
    helper: "dataroom__dataRoomTypeSelectDialog__",
    dataScience: "dataroom__dataRoomTypeSelectDialog__DataScience",
    mediaInsights: "dataroom__dataRoomTypeSelectDialog__MediaInsights",
    media: "dataroom__dataRoomTypeSelectDialog__Media",
    lookalikeMedia: "dataroom__dataRoomTypeSelectDialog__LookalikeMedia",
    continue: "dataroom__dataRoomTypeSelectDialog__continue"
  },
  dataRoomComputePermissionSelect: {
    button: "dataroom__dataRoomComputePermissionSelect__button",
    helper: "dataroom__dataRoomComputePermissionSelect__",
    selectAll: "dataroom__dataRoomComputePermissionSelect__all"
  },
  dataRoomDataPermissionSelect: {
    button: "dataroom__dataRoomDataPermissionSelect__button",
    helper: "dataroom__dataRoomDataPermissionSelect__",
    selectAll: "dataroom__dataRoomDataPermissionSelect__all"
  },
  addParticipants: {
    newParticipant: "dataroom__addParticipants__newParticipant"
  },
  dataroomPublishDialog: {
    publishButton: "dataroom__dataroomPublishDialog__publishButton"
  }
}, r = {
  participantRoleSelect: {
    helper: "dataRoomCreation__participantRoleSelect__",
    advertiser: "dataRoomCreation__participantRoleSelect__advertiser",
    publisher: "dataRoomCreation__participantRoleSelect__publisher",
    dataPartner: "dataRoomCreation__participantRoleSelect__dataPartner",
    agency: "dataRoomCreation__participantRoleSelect__agency",
    observer: "dataRoomCreation__participantRoleSelect__observer",
    custom: "dataRoomCreation__participantRoleSelect__custom"
  },
  collaborationTypeSelect: {
    overlapAnalysis: "dataRoomCreation__collaborationTypeSelect__overlapAnalysis",
    insights: "dataRoomCreation__collaborationTypeSelect__insights",
    remarketing: "dataRoomCreation__collaborationTypeSelect__remarketing",
    ruleBased: "dataRoomCreation__collaborationTypeSelect__ruleBased",
    lookalike: "dataRoomCreation__collaborationTypeSelect__lookalike"
  },
  dataRoomTypeSelect: {
    helper: "dataroom__dataRoomTypeSelect__",
    dataScience: "dataroom__dataRoomTypeSelect__DataScience",
    mediaInsights: "dataroom__dataRoomTypeSelect__MediaInsights",
    media: "dataroom__dataRoomTypeSelect__Media",
    lookalikeMedia: "dataroom__dataRoomTypeSelect__LookalikeMedia",
    measurement: "dataroom__dataRoomTypeSelect__Measurement",
    continue: "dataroom__dataRoomTypeSelect__continue"
  },
  currentUserRoleSelect: {
    helper: "dataroom__dataRoomTypeSelect__",
    advertiser: "dataroom__dataRoomTypeSelect__advertiserButton",
    publisher: "dataroom__dataRoomTypeSelect__publisherButton",
    dataPartner: "dataroom__dataRoomTypeSelect__dataPartnerButton"
  }
}, n = {
  dataNodeAddNewField: {
    dataToggleTable: "dataNode__dataNodeAddNewField__dataToggleTable",
    dataToggleFile: "dataNode__dataNodeAddNewField__dataToggleFile",
    newDataButton: "dataNode__dataNodeAddNewField__newDataButton"
  },
  dataNodeCreator: {
    toggleEditor: "dataNode__dataNodeAddNewField__toggleEditor"
  },
  tableColumnConstructor: {
    tableColumn: "dataNode__tableColumnConstructor__tableColumn"
  },
  dataNodeEditableTile: {
    nameInput: "dataNode__dataNodeEditableTile__nameInput",
    nameInputHelper: "dataNode__dataNodeEditableTile__nameInputHelper"
  }
}, l = {
  dataScienceDataRoomCreateDialog: {
    nameInput: "dataScienceDataRoom__dataScienceDataRoomCreateDialog__nameInput",
    createButton: "dataScienceDataRoom__dataScienceDataRoomCreateDialog__createButton",
    importConfig: "dataScienceDataRoom__dataScienceDataRoomCreateDialog__importConfig"
  }
}, d = {
  dataLabValidation: {
    dataLabValidationButton: "dataLabs__dataLabValidation__dataLabValidationButton"
  },
  dataLabScreen: {
    newDataLab: "dataLabs__dataLabScreen__newDataLab"
  },
  dataNodeActions: {
    helper: "dataLabs__dataNodeActions__",
    dataset: "dataLabs__dataNodeActions__dataset",
    dataSetMatching: "dataLabs__dataNodeActions__dataSetMatching",
    datasetSegments: "dataLabs__dataNodeActions__datasetSegments",
    datasetEmbeddings: "dataLabs__dataNodeActions__datasetEmbeddings",
    dataSetDemographics: "dataLabs__dataNodeActions__dataSetDemographics"
  },
  dataLabCreateDialog: {
    nameInput: "dataLabs__dataLabCreateDialog__nameInput",
    matchingDataCheckbox: "dataLabs__dataLabCreateDialog__matchingDataCheckbox",
    demographicDataCheckbox: "dataLabs__dataLabCreateDialog__demographicDataCheckbox",
    segmentsDataCheckbox: "dataLabs__dataLabCreateDialog__segmentsDataCheckbox",
    userEmbeddingDataCheckbox: "dataLabs__dataLabCreateDialog__userEmbeddingDataCheckbox",
    matchingIdSelector: "dataLabs__dataLabCreateDialog__matchingIdSelector",
    matchingIdHelper: "dataLabs__dataLabCreateDialog__",
    matchingIdString: "dataLabs__dataLabCreateDialog__string",
    matchingIdEmail: "dataLabs__dataLabCreateDialog__email",
    matchingIdHashedEmail: "dataLabs__dataLabCreateDialog__hashed_email",
    matchingIdPhoneNumber: "dataLabs__dataLabCreateDialog__phone_number",
    matchingIdHashedPhoneNumber: "dataLabs__dataLabCreateDialog__hashed_phone_number",
    numEmbeddingsInput: "dataLabs__dataLabCreateDialog__numEmbeddingsInput",
    submitButton: "dataLabs__dataLabCreateDialog__submitButton"
  }
}, s = {
  encryptAndPublish: {
    publishButton: "draftDataRoom__encryptAndPublish__publishButton"
  }
}, c = {
  tabList: {
    dcrList: "publisherPortal__tabList__dcrList",
    dataLabs: "publisherPortal__tabList__dataLabs",
    publisherConfigurations: "publisherPortal__tabList__publisherConfigurations"
  },
  displayConfiguration: {
    createButton: "publisherPortal__displayConfiguration__createButton",
    deleteButton: "publisherPortal__displayConfiguration__deleteButton",
    deleteDialogConfirmationButton: "publisherPortal__displayConfiguration__deleteDialogConfirmationButton"
  },
  upsertDisplayConfigurationDialog: {
    logoHelper: "publisherPortal__upsertDisplayConfigurationDialog__logo__",
    publisherName: "publisherPortal__upsertDisplayConfigurationDialog__publisherName",
    description: "publisherPortal__upsertDisplayConfigurationDialog__description",
    collaborativeUsersSelector: "publisherPortal__upsertDisplayConfigurationDialog__collaborativeUsersSelector",
    collaborativeUsersSelectorOptionHelper: "publisherPortal__upsertDisplayConfigurationDialog__collaborativeUsersSelectorOption__",
    activeMarketsSelector: "publisherPortal__upsertDisplayConfigurationDialog__activeMarketsSelector",
    activeMarketsSelectorOptionHelper: "publisherPortal__upsertDisplayConfigurationDialog__activeMarketsSelectorOptionHelper__",
    submitButton: "publisherPortal__upsertDisplayConfigurationDialog__submitButton"
  },
  activationConfigurations: {
    createButton: "publisherPortal__activationConfigurations__createButton",
    recordHelper: "publisherPortal__activationConfigurations__configuration__",
    recordDeleteButton: "publisherPortal__activationConfigurations__configurationDeleteButton",
    deleteDialogConfirmationButton: "publisherPortal__activationConfigurations__deleteDialogConfirmationButton"
  },
  createActivationConfigurationDialog: {
    name: "publisherPortal__createActivationConfigurationDialog__name",
    participantsSelector: "publisherPortal__createActivationConfigurationDialog__participantsSelector",
    participantsSelectorOptionHelper: "publisherPortal__createActivationConfigurationDialog__participantsSelectorOption__",
    featuresSelector: "publisherPortal__createActivationConfigurationDialog__featuresSelector",
    featuresSelectorOptionHelper: "publisherPortal__createActivationConfigurationDialog__featuresSelectorOption__",
    matchingIdSelector: "publisherPortal__createActivationConfigurationDialog__matchingIdSelector",
    matchingIdSelectorOptionHelper: "publisherPortal__createActivationConfigurationDialog__matchingIdSelectorOption__",
    advertiserDomain: "publisherPortal__createActivationConfigurationDialog__advertiserDomain",
    matchAnyDomain: "publisherPortal__createActivationConfigurationDialog__matchAnyDomain",
    submitButton: "publisherPortal__createActivationConfigurationDialog__submitButton"
  }
}, m = {
  tabList: {
    dcrList: "dataPartnerPortal__tabList__dcrList",
    configurations: "dataPartnerPortal__tabList__configurations",
    dataLabs: "dataPartnerPortal__tabList__dataLabs"
  },
  displayConfiguration: {
    createButton: "dataPartnerPortal__displayConfiguration__createButton",
    deleteButton: "dataPartnerPortal__displayConfiguration__deleteButton",
    deleteDialogConfirmationButton: "dataPartnerPortal__displayConfiguration__deleteDialogConfirmationButton"
  },
  upsertDisplayConfigurationDialog: {
    logoHelper: "dataPartnerPortal__upsertDisplayConfigurationDialog__logo__",
    name: "dataPartnerPortal__upsertDisplayConfigurationDialog__name",
    description: "dataPartnerPortal__upsertDisplayConfigurationDialog__description",
    collaborativeUsersSelector: "dataPartnerPortal__upsertDisplayConfigurationDialog__collaborativeUsersSelector",
    collaborativeUsersSelectorOptionHelper: "dataPartnerPortal__upsertDisplayConfigurationDialog__collaborativeUsersSelectorOption__",
    activeMarketsSelector: "dataPartnerPortal__upsertDisplayConfigurationDialog__activeMarketsSelector",
    activeMarketsSelectorOptionHelper: "dataPartnerPortal__upsertDisplayConfigurationDialog__activeMarketsSelectorOptionHelper__",
    submitButton: "dataPartnerPortal__upsertDisplayConfigurationDialog__submitButton"
  },
  usageConfigurations: {
    createButton: "dataPartnerPortal__usageConfigurations__createButton",
    recordHelper: "dataPartnerPortal__usageConfigurations__configuration__",
    recordDeleteButton: "dataPartnerPortal__usageConfigurations__configurationDeleteButton",
    deleteDialogConfirmationButton: "dataPartnerPortal__usageConfigurations__deleteDialogConfirmationButton"
  },
  createUsageConfigurationDialog: {
    name: "dataPartnerPortal__createUsageConfigurationDialog__name",
    participantsSelector: "dataPartnerPortal__createUsageConfigurationDialog__participantsSelector",
    participantsSelectorOptionHelper: "dataPartnerPortal__createUsageConfigurationDialog__participantsSelectorOption__",
    featuresSelector: "dataPartnerPortal__createUsageConfigurationDialog__featuresSelector",
    featuresSelectorOptionHelper: "dataPartnerPortal__createUsageConfigurationDialog__featuresSelectorOption__",
    matchingIdSelector: "dataPartnerPortal__createUsageConfigurationDialog__matchingIdSelector",
    matchingIdSelectorOptionHelper: "dataPartnerPortal__createUsageConfigurationDialog__matchingIdSelectorOption__",
    advertiserDomain: "dataPartnerPortal__createUsageConfigurationDialog__advertiserDomain",
    matchAnyDomain: "dataPartnerPortal__createUsageConfigurationDialog__matchAnyDomain",
    submitButton: "dataPartnerPortal__createUsageConfigurationDialog__submitButton"
  }
}, u = {
  mediaInsightDcrCreateSelectOrganizationRole: {
    advertiser: "mediaInsightsDcr__mediaInsightDcrCreateSelectOrganizationRole__advertiserButton",
    publisher: "mediaInsightsDcr__mediaInsightDcrCreateSelectOrganizationRole__publisherButton",
    dataPartner: "mediaInsightsDcr__mediaInsightDcrCreateSelectOrganizationRole__dataPartnerButton"
  },
  mediaInsightDcrCreateSelectPublisher: {
    invitePublisher: "mediaInsightsDcr__mediaInsightDcrCreateSelectPublisher__invitePublisherButton"
  },
  mediaInsightsDcrCreateCollaborationStep: {
    insightDataRoomName: "mediaInsightsDcr__mediaInsightsDcrCreateCollaborationStep__insightDataRoomName"
  },
  mediaInsightsDcrCreateCollaborationRequestStep: {
    requestTextarea: "mediaInsightsDcr__mediaInsightsDcrCreateCollaborationRequestStep__requestTextarea"
  },
  collaborationConfigurationStepRole: {
    publisherEmail: "components__collaborationConfigurationStepRole__publisherEmail",
    advertiserEmail: "components__collaborationConfigurationStepRole__advertiserEmail",
    dataPartnerEmail: "components__collaborationConfigurationStepRole__dataPartnerEmail",
    agencyEmail: "components__collaborationConfigurationStepRole__agencyEmail",
    observerEmail: "components__collaborationConfigurationStepRole__observerEmail",
    allowedFeaturesHelper: "components__collaborationConfigurationStepRole__",
    allowedFeaturesInsights: "components__collaborationConfigurationStepRole__Insights",
    allowedFeaturesLookalike: "components__collaborationConfigurationStepRole__Lookalike",
    allowedFeaturesRetargeting: "components__collaborationConfigurationStepRole__Retargeting"
  },
  mediaInsightsDcrCreateWizard: {
    submitButton: "components__mediaInsightsDcrCreateWizard__submitButton",
    requestCollaborationButton: "components__mediaInsightsDcrCreateWizard__requestCollaborationButton"
  },
  matchingIdSelector: {
    matchingId: "components__matchingIdSelector__matchingId",
    hashedEmail: "components__matchingIdSelector__hashed_email",
    helper: "components__matchingIdSelector__"
  }
}, p = {
  dataRoomName: {
    nameInput: "measurementDcr__dataRoomName__nameInput"
  }
}, g = {
  actions: {
    actionButton: "components__actions__actionButton",
    actionButtonHelper: "components__actions__",
    exportToJsonButton: "components__actions__Export to JSON"
  },
  codeEditor: {
    input: "components__codeEditor__input"
  },
  alert: {
    alertHelper: "components__alert__",
    error: "components__alert__error",
    success: "components__alert__success",
    warning: "components__alert__warning",
    info: "components__alert__info",
    copied: "components__alert__copied",
    bug: "components__alert__bug",
    network: "components__alert__network",
    default: "components__alert__default"
  },
  dataReprovisioner: {
    backButton: "components__dataReprovisioner__backButton"
  },
  gettingStarted: {
    newDcrButton: "components__gettingStarted__newdcrButton"
  },
  imageUploader: {
    triggerButton: "components__imageUploader__triggerButton",
    openExplorerButton: "components__imageUploader__openExplorerButton",
    submitButton: "components__imageUploader__submitButton"
  },
  imageCropper: {
    fileInput: "components__imageCropper__fileInput"
  }
}, b = {
  sidebar: t,
  containers: a,
  computeNode: e,
  keychain: o,
  adminPortal: _,
  dataroom: i,
  dataRoomCreation: r,
  dataNode: n,
  dataScienceDataRoom: l,
  dataLabs: d,
  draftDataRoom: s,
  publisherPortal: c,
  dataPartnerPortal: m,
  mediaInsightsDcr: u,
  measurementDcr: p,
  components: g
};
export {
  P as Key,
  f as LabeledPromise,
  y as ProgressPromise,
  I as SmartVec,
  C as exceptions,
  v as sortNumericRange,
  b as testIds
};
//# sourceMappingURL=index.js.map
